import { Injectable } from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class InjectTokenInterceptorService implements HttpInterceptor{

  constructor(
    private authenticationService: AuthenticationService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.url.startsWith(environment.BASE_URL_API)){
      const accessToken = this.authenticationService.getAccessToken();
      if (!!accessToken) {
        req = req.clone({
          setHeaders: {
            Authorization: "Bearer " + accessToken,
            Accept: 'application/json'
          },
        });
      }
      return next.handle(req);
    }
    return next.handle(req);
  }
}
